import {
  IValueSpecifiable, instanceOfIValueSpecifiable,
} from "../../../../base/domain/entity";

export interface IHistoryRecord<T = string> extends IValueSpecifiable<T> {
  recorded?: Date;  // v1の古い版だと記録されてない事がある模様.未指定でも対応できるようなしも許容する.
}

export function instanceOfIHistoryRecord<T = string>(instance: any): instance is IHistoryRecord<T> {
  return instance
      && (instance.recorded !== undefined)
      && instanceOfIValueSpecifiable<T>(instance);
}
